import { render, staticRenderFns } from "./ModalEditarLaudosVinculados.vue?vue&type=template&id=cf93cbee&lang=pug"
import script from "./ModalEditarLaudosVinculados.vue?vue&type=script&lang=js"
export * from "./ModalEditarLaudosVinculados.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarLaudosVinculados.vue?vue&type=style&index=0&id=cf93cbee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports